import React, { useState, useEffect, useCallback } from 'react';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container, Card } from '@mui/material';
import SellersHeader from './SellersHeader';
import SellersContent from './SellersContent';
import { useAuth } from 'src/hooks/useAuth';
import { API } from '../../../config/config';
import Footer from 'src/components/Footer';

const SellersComponent = () => {
  const { enhancedFetch } = useAuth();
  const [sellersData, setSellersData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    enhancedFetch(`${API.HOST}/api/v1/sellers`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((data) => {
        if (!data.error) {
          setSellersData(data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [reload]);


  return (
    <div>
      <PageTitleWrapper>
        <SellersHeader sellers={sellersData} setSellersData={setSellersData} />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <SellersContent
          sellers={sellersData}
          setSellersData={setSellersData}
          isLoading={isLoading}
          fetchData={fetchData}
          reload={reload}
          setReload={setReload}

        />
      </Container>
      <Footer />
    </div>
  );
};

export default SellersComponent;
